import React from "react"
import { Switch } from "@mui/material"
import i18n from "@/i18n"
import TimeRangeInput from "./time_range_input"

const STYLES = {
  scheduleItem: "flex items-center gap-4 p-4 rounded-lg border",
  scheduleItemOpen: "bg-gray-50 border-gray-200",
  scheduleItemClosed: "bg-red-50 border-red-300",
  dayLabel: "font-medium w-32",
  statusLabel: "flex items-center gap-2 w-32",
} as const

interface RegularHourItemProps {
  weekday: string
  closed: boolean
  startTime: string
  endTime: string
  dayIndex?: number
  onClosedChange: (closed: boolean) => void
  onStartTimeChange: (time: string) => void
  onEndTimeChange: (time: string) => void
}

const RegularHourItem: React.FC<RegularHourItemProps> = ({
  weekday,
  closed,
  startTime,
  endTime,
  dayIndex,
  onClosedChange,
  onStartTimeChange,
  onEndTimeChange,
}) => {
  return (
    <div
      className={`${STYLES.scheduleItem} ${closed ? STYLES.scheduleItemClosed : STYLES.scheduleItemOpen}`}
      data-testid={`settings-venue-hours-regular-${dayIndex ?? 0}`}
    >
      <span className={STYLES.dayLabel}>{weekday}</span>

      <div className={STYLES.statusLabel}>
        <Switch
          checked={!closed}
          onChange={(e) => onClosedChange(!e.target.checked)}
          size="small"
          data-testid={`settings-venue-hours-regular-${dayIndex ?? 0}-toggle`}
        />
        <span className={closed ? "text-red-600 font-medium" : "text-green-600 font-medium"}>
          {closed
            ? i18n.t("app.settings.venues.opening_hours.closed")
            : i18n.t("app.settings.venues.opening_hours.open")}
        </span>
      </div>

      <TimeRangeInput
        startTime={startTime}
        endTime={endTime}
        disabled={closed}
        onStartTimeChange={onStartTimeChange}
        onEndTimeChange={onEndTimeChange}
      />
    </div>
  )
}

export default RegularHourItem
